<template>
  <Drawer
    custom-class="pg-drawer-form"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :size="size"
    @close="close"
    @closed="closed"
    @open="getFormData"
  >
    <div class="pg-drawer-form__content">
      <div class="pg-drawer-form__content-form">
        <PgTopRemind
          class="pg-drawer-form__content-form-remind"
          :errors="submitErrors"
        ></PgTopRemind>
        <PgForm
          v-if="!!formData"
          ref="pgFormRef"
          :formItems="formItems"
          :formItemsCode="formItemsCode"
          :extendCompileData="extendCompileData"
          :model="formData"
        ></PgForm>
        <slot name="content"></slot>
      </div>
      <div class="pg-drawer-form__content-footer">
        <ElButton type="primary" round @click="submit" :loading="sureLoading || submitLoading">
          {{ sureText ?? '确定' }}
        </ElButton>
      </div>
    </div>
  </Drawer>
</template>
<script setup>
import { Drawer } from 'element-ui'
import { PgForm } from '../../form/index'
import {
  useDrawerPack,
  useBeforValueActionsProvideChild,
  useFormModifyDialog,
} from '../../../hooks/index'
import { toRefs, reactive } from 'vue'
import { useGetForm } from '../../../hooks/use-get-form'
import { useSure } from '../hook/use-sure'
import { PgTopRemind } from '../../top-remind/index'

const props = defineProps({
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '选择',
  },
  size: [String, Number],
  formItems: [Array, Object],
  formItemsCode: String,
  extendCompileData: Object,
  formModel: Object,
  formUrl: String,
  formMethod: String,
  formParam: [Object, Function],
  getFormDataAfter: Function,
  submitUrl: String,
  submitParam: Object,
  // 提交参数与表单结构不一致时使用，如需要对formData中的部分字段进行提交
  submitParamCompieFrom: [String, Object],
  successTip: String,
  onOK: Function,
  sureLoading: Boolean,
  sureText: String,
  forceSubmitText: String,
  modifyTip: Boolean,
})

const emit = defineEmits(['update:visible', 'close', 'closed', 'on-cancel', 'on-ok'])

const { setModifyFlag, checkModifyFlag } = useFormModifyDialog(props.modifyTip)

const {
  formModel,
  formMethod,
  formUrl,
  formParam,
  visible,
  submitUrl,
  getFormDataAfter,
  submitParam,
  submitParamCompieFrom,
  forceSubmitText,
} = toRefs(props)
const { showDrawer, close, closed, onCancel, closeDrawer } = useDrawerPack(
  visible,
  emit,
  checkModifyFlag
)
const { formData, getFormData } = useGetForm({
  formModel,
  formUrl,
  formParam,
  getFormDataAfter,
  formMethod,
})

const { pgFormRef, submitLoading, sure, submitErrors } = useSure({
  formData,
  submitUrl,
  submitParam,
  submitParamCompieFrom,
  forceSubmitText,
  successTip: props.successTip,
})
const submit = async () => {
  const res = await sure()
  if (res) {
    setModifyFlag(false)
    if (props.onOK) {
      props.onOK(res)
    } else {
      closeDrawer()
      emit('on-ok', res)
    }
  }
}

useBeforValueActionsProvideChild({
  formReactive: reactive({ formData }),
  actions: null,
  callback: () => {
    if (props.modifyTip) {
      setModifyFlag(true)
    }
  },
})
</script>
<style lang="scss">
@import '../style/drawer-form.scss';
</style>
